import { useState } from 'react';
import '../styles/resultmodal.css';

export default function ResultNotAvailableModal({ onClose, onCheckAgain }) {
  const [isChecking, setIsChecking] = useState(false);

  const handleCheckAgain = async () => {
    setIsChecking(true);
    try {
      await onCheckAgain();
    } finally {
      setIsChecking(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="result-modal" onClick={(e) => e.stopPropagation()}>

        <div className="modal-header-gradient"></div>

        <button className="modal-close-btn" onClick={onClose}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>

        <div className="modal-icon-container">
          <div className="modal-icon-bg">
            <div className="dashed-circle outer-circle"></div>
            <div className="dashed-circle inner-circle"></div>
            <div className="icon-inner">
              <svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <polyline points="12 6 12 12 16 14"/>
              </svg>
            </div>
          </div>
        </div>

        <div className="modal-content">
          <h2 className="modal-heading">YOUR RESULT ISN'T AVAILABLE YET</h2>

          <div className="modal-description">
            <p className="modal-text">
              Your test has been submitted successfully. We're currently evaluating your responses.
            </p>
            <p className="modal-subtext">
              Results are usually available within <strong>30 minutes</strong>.
            </p>
          </div>

          <div className="modal-info-box">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#1E40AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="16" x2="12" y2="12"/>
              <line x1="12" y1="8" x2="12.01" y2="8"/>
            </svg>
            <p>No action is needed from your side. You'll be able to view your result once it's ready.</p>
          </div>

          <div className="modal-buttons">
            <button className="modal-btn secondary" onClick={handleCheckAgain} disabled={isChecking}>
              {isChecking ? (
                <>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ animation: 'spin 1s linear infinite' }}>
                    <path d="M21 12a9 9 0 1 1-6.219-8.56"/>
                  </svg>
                  Checking...
                </>
              ) : (
                <>
                  <svg width="16" height="16" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
                    <path d="M1.86841 7.4706C1.86841 5.98468 2.45869 4.55961 3.50939 3.50891C4.5601 2.4582 5.98516 1.86792 7.47109 1.86792C9.03738 1.87381 10.5408 2.48498 11.6669 3.57362L13.0738 4.98052" stroke="currentColor" strokeWidth="1.24504" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M13.074 1.86792V4.98052H9.96143" stroke="currentColor" strokeWidth="1.24504" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M13.0738 7.4707C13.0738 8.95663 12.4835 10.3817 11.4328 11.4324C10.3821 12.4831 8.95701 13.0734 7.47109 13.0734C5.9048 13.0675 4.40142 12.4563 3.2753 11.3677L1.86841 9.96078" stroke="currentColor" strokeWidth="1.24504" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M4.98101 9.96118H1.86841V13.0738" stroke="currentColor" strokeWidth="1.24504" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Check Again
                </>
              )}
            </button>
            <button className="modal-btn primary" onClick={onClose}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                <polyline points="9 22 9 12 15 12 15 22"/>
              </svg>
              Go to Home
            </button>
          </div>
        </div>

      </div>
    </div>
  );
}